import { render, staticRenderFns } from "./pindaanPengesahanList.vue?vue&type=template&id=57b2f4f0&"
import script from "./pindaanPengesahanList.vue?vue&type=script&lang=js&"
export * from "./pindaanPengesahanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports